import { createContext, useContext, useEffect, useState } from "react";
import translations, { LANGS } from "./translations";

const LS_KEY = "segreto_language";
const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("pl");
  const [needsSelection, setNeedsSelection] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(LS_KEY);
      if (saved && LANGS.includes(saved)) {
        setLangState(saved);
      } else {
        setNeedsSelection(true);
      }
    } catch (e) {
      setNeedsSelection(true);
    }
  }, []);

  const setLang = (l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    try { localStorage.setItem(LS_KEY, l); } catch (e) { /* ignore */ }
    setNeedsSelection(false);
  };

  const dict = translations[lang] || translations.pl;
  const t = dict; // direct access, e.g. t.home.heroTitle1

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, needsSelection, setNeedsSelection }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside <LanguageProvider>");
  return ctx;
}
